import posthog from 'posthog-js';

const key = process.env.REACT_APP_POSTHOG_KEY || '';

if (key) {
  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    capture_pageview: false,
    persistence: 'localStorage+cookie',
    defaults: '2026-01-30',
    loaded: (ph) => {
      ph.capture('posthog_boot_test', { source: 'startup' });
    },
  });
}

export default posthog;